<template>
  <div class="row">
    <div class="col-12">
      <wistia-video :video-id="videoId" />
    </div>
    <div class="col-12">
      <quote-carousel-block :quotes="quotes" :id="id" :is-dark-bg="isDarkBg" />
    </div>
  </div>
</template>

<script>
import WistiaVideo from "./WistiaVideo";
import QuoteCarouselBlock from "../../stream-page/blocks/QuoteCarouselBlock";

export default {
  name: "VideoWithQuote",
  components: { QuoteCarouselBlock, WistiaVideo },
  props: {
    header: Object,
    videoId: String,
    quotes: Array,
    id: Number,
    isDarkBg: Boolean,
  },
};
</script>

<style scoped lang="scss">
::v-deep .simple-text {
  & p > img {
    width: 100%;
  }
}
</style>
